import _qrcode from 'qrcode-generator';
const qrcode = _qrcode;
qrcode.stringToBytes = (data) => data;
export { qrcode };
